import React from "react";
import { Check } from "@phosphor-icons/react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";

export default function Expertise() {
  const { t } = useLang();
  return (
    <section id="expertise" data-testid="expertise-section" className="relative py-24 lg:py-36 bg-navy">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.expertise.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.expertise.title}</h2>
          </Reveal>
        </div>

        <div className="mt-16 grid lg:grid-cols-3 gap-6">
          {t.expertise.pillars.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.08} y={50}>
              <div className="h-full border border-white/10 rounded-sm p-8 lg:p-10 bg-surface/40 hover:border-gold/40 transition-colors duration-500 relative overflow-hidden group">
                <span className="font-serif text-7xl text-outline block leading-none">{p.n}</span>
                <h3 className="font-serif text-2xl text-white mt-6">{p.title}</h3>
                <ul className="mt-8 space-y-4">
                  {p.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-white/70">
                      <Check weight="bold" size={18} className="text-gold mt-0.5 shrink-0" />
                      <span className="leading-relaxed">{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
